// screenRoutes.js
export const screenRoutes = {
  'DASHBOARD': '/dashboard',
  'VENDOR_MASTER': '/vendor-master',
  'CUSTOMER_MASTER': '/customer-master',
  'PRODUCT_MASTER': '/product-master',
  'BRANCH_MASTER': '/branch-master',
  'WAREHOUSE': '/location-master',
  'DEPARTMENT_MASTER': '/department-master',
  'USER_MASTER': '/user-master',
  'RFQ_MASTER': '/rfq-items-master',
  'PURCHASE_ORDER': '/purchase-order-items',
  'MRN_MASTER': '/Material-Receipt-Note',
  'SALES_ORDER': '/sales-master',
  'DELIVERY_NOTE': '/delivery-note',
  'STOCK_IN': '/stockin',
  'STOCK_OUT': '/stockout',
  'STOCK_SUMMARY': '/stock-summary-report',
  'CURRENCY_MASTER': '/currency-master',
  'TAX_MASTER': '/tax-master',
  'CATEGORY': '/category-master',
  'SUBCATEGORY': '/subcategory-master',
  'PROFILE': '/profile',
  'COMPANY': '/company-information',
  'BILL_OF_MATERIAL':'/bill-of-material',
  'PRODUCTION_ORDER':'/production-order-master',
  'ISSUE_FOR_PRODUCTION':'/issue-for-production',
  'RECEIPT_FROM_PRODUCTION':'/receipt-from-production',
  'SURVEY_BOQ':'/survey-boq',
  'PROJECT_LIST':'/project-list',
  'FEEDER':'/feeder-list',
  'SITE_INDENT':'/site-indent',
  'APPROVAL_FLOW':'/approval-flow',
  'MATERIAL_ISSUE':'/material-issue',
  'MATERIAL_RECEIVE':'/material-receive',
  'DPR':'/dpr',
  'API_MAPPING':'/bc-api-mapping',
  'MATERIAL_RETURN':'material-return',
  'COMPARISON_REPORT': '/comparison-report',
  'ACTIVITY_LIST': '/activity-list',
  'SESSION_SERVICE': '/session-service',
};

// Create a reverse mapping for route to screen code
export const routeToScreenCode = Object.fromEntries(
  Object.entries(screenRoutes).map(([code, route]) => [route, code])
);